import { Navigate, useParams } from "react-router-dom";

import APP_ROUTES from "../../../../routers/routeConstants";

import GinoChatPage from "../GinoChatPage";

// Resuming a past GINO conversation. The interactive GinoChatPage already
// contains all the history-restore + resume machinery; binding it to this
// room's chatId makes the history view fully interactive. The `key` forces a
// clean remount when navigating between rooms so feeds never bleed across them.
const GinoChatHistoryPage = () => {
  const { chatId } = useParams();

  if (!chatId) return <Navigate to={APP_ROUTES.GINO_CHAT_HISTORY} replace />;

  return <GinoChatPage key={chatId} />;
};

export default GinoChatHistoryPage;
